import { render, staticRenderFns } from "./items.vue?vue&type=template&id=db2e010c&scoped=true"
import script from "./items.vue?vue&type=script&lang=js"
export * from "./items.vue?vue&type=script&lang=js"
import style0 from "./items.vue?vue&type=style&index=0&id=db2e010c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2e010c",
  null
  
)

export default component.exports